import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';

const ContentErrorRateTable = (props) => (
  <KpiTable
    title="Error report"
    description="The number represents the average error opened per unit."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    nameColumnPath={props.nameColumnPath}
    nameColumnRender={props.nameColumnRender}
    feedbackColorRender={props.feedbackColorRender}
  />
);

ContentErrorRateTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

ContentErrorRateTable.defaultProps = {
  nameColumnPath: 'order',
};

export default ContentErrorRateTable;
